/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Used_Token_PasswordInputs */



/**
* | output |
* | --- |
* | "Your password has already been reset. You can log in." |
*
* @param {Used_Token_PasswordInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const used_token_password = /** @type {((inputs?: Used_Token_PasswordInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Used_Token_PasswordInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your password has already been reset. You can log in.")
	return /** @type {LocalizedString} */ ("Votre mot de passe a déjà été réinitialisé. Vous pouvez vous connecter.")
});